import Joi from '@hapi/joi'

export function validateProperty(target, schemaObject) {
    const obj = { [target.name]: target.value }
    const singleSchema = Joi.object({ [target.name]: schemaObject[target.name]})
    const result = singleSchema.validate(obj)
    return result.error ? result.error.details[0].message : null
}